import React from 'react';
import { Title, Card, ButtonGroup, Icon, Text } from '@upsales/components';
import './FileStorageAppHeader.scss';

const FileStorageAppHeader = ({ app, onDisconnect }) => (
	<div className="FileStorageApps__app-header">
		<Card
			style={{
				backgroundImage: `url(${app.imageLink})`,
				color: app.color
			}}
		/>
		<Title>{app.name}</Title>
		<ButtonGroup>
			<div onClick={onDisconnect} className="disconnect">
				<Icon name="link" color="bright-blue" />
				<Text color="bright-blue">{Tools.$translate('default.disconnect')}</Text>
			</div>
		</ButtonGroup>
	</div>
);

export default FileStorageAppHeader;
